import React, { Component } from 'react';
import Cfa3SubscriptionCheck from '../../RestAPI/Cfa3Subscription';
import PartnerCfa3SubscriptionCheck from '../../RestAPI/PartnerSubscription/Cfa3Subscription';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
import AlertMessage from '../../config/alertMessage';
// import Axios from 'axios';
// import { saveAs } from 'file-saver';
import language from '../../../assets/languages/language';
import ModalComponent from '../../Common/Modal';
import AppRoutes from '../../config/AppRoutes';
import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { openPDF } from '../../../common/function';
import { examNameAccordingToDB } from '../../../common/constant';
import { messages } from '../../../common/messages';
import {autorun} from "mobx";
import UserStore from "../../../store/userStore";

/* eslint-disable*/

class Notes extends Component {
  constructor(props) {
    super(props);
    var messageTitle_cfa = `<i class="icon-info icons font-2xl d-block "></i>`;
    this.state = {
      alert_status: false,
      MessageTitle: messageTitle_cfa,
      MessageContent: AlertMessage.messageContent_cfa_1,
      chapters: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      showFreePremium: '',
      selectedmenu: 'cfa_3',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      lastRecord: '',
      isNotesNotFound: false,
      lastAttempt: false,
      pdfLoading: true,
      dropdownOpen: false,
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    //this._getReadings = this._getReadings.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }

  _getReadings = async (chapter, e) => {
    if (chapter.chapter_no === 1) {
      let path = AppRoutes.CFA3_NOTES_READINGS.replace(':chapter', chapter.chapter_no);
      this.context.router.push({
        pathname: path,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapter: chapter.chapter_no,
        },
      });
    } else {
      var final_exam = [];
      var data = { token: this.state.token, idname: this.state.idname };
      FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
        if (resp.profileInfo.role === 'partner') {
          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
            this.toggleAlert();
          } else {
            this.setState({
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });
            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;

            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              async resp_exam => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  const examPlanData = resp_exam.examPlan[0];
                  isInArray_var = await PartnerCfa3SubscriptionCheck.checkCfa3NotesSubscription(
                    selectedmen,
                    exam_data,
                    this.state.cfaUnlimitedPackage,
                    this.state.cfaUnlimitedActiveExam,
                    examPlanData,
                  );
                  if (isInArray_var) {
                    let path = AppRoutes.CFA3_NOTES_READINGS.replace(
                      ':chapter',
                      chapter.chapter_no,
                    );
                    this.context.router.push({
                      pathname: path,
                      state: {
                        token: this.state.token,
                        idname: this.state.idname,
                        chapter: chapter.chapter_no,
                      },
                    });
                  } else {
                    this.toggleAlert();
                  }
                } else {
                }
              },
            );
          }
        } else {
          if (
            resp.profileInfo.exam_selected === '' &&
            resp.profileInfo.cfaUnlimitedPackage == '' &&
            resp.profileInfo.cfaUnlimitedActiveExam == ''
          ) {
            this.toggleAlert();
          } else {
            this.setState({
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });
            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              resp_exam => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;

                  isInArray_var = Cfa3SubscriptionCheck.checkCfa3NotesSubscription(
                    selectedmen,
                    exam_data,
                    this.state.cfaUnlimitedPackage,
                    this.state.cfaUnlimitedActiveExam,
                  );

                  //console.log(isInArray_var);
                  if (isInArray_var) {
                    let path = AppRoutes.CFA3_NOTES_READINGS.replace(
                      ':chapter',
                      chapter.chapter_no,
                    );
                    this.context.router.push({
                      pathname: path,
                      state: {
                        token: this.state.token,
                        idname: this.state.idname,
                        chapter: chapter.chapter_no,
                      },
                    });
                  } else {
                    this.toggleAlert();
                  }
                } else {
                }
              },
            );
          }
        }
      });
    }
  };

  async componentDidMount() {
    // console.log('working')
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };

    FD.callAPI(App_data.backend_api + '/cfa3_notes/getChapters', data).then(resp => {
      if (resp.success) {
        if (resp.chapters.length === 0) {
          this.setState({ isNotesNotFound: true });
        }
        this.setState({ ValidToken: true, chapters: resp.chapters });
        var data = { token: this.state.token, idname: this.state.idname };
        FD.callAPI(App_data.backend_api + '/cfa3_notes/getlastReadNotes', data).then(response => {
          if (response.success) {
            this.setState({
              lastRecord: response.data,
              lastAttempt: true,
            });
          }
        });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });

    var final_exam = [];
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
    this.dispose = autorun(async () => {

      const resp = UserStore;

      if(resp == null || resp.profileInfo == null){
        return;
      }

      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({ showFreePremium: true });
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                const examPlanData = resp_exam.examPlan[0];
                isInArray_var = await PartnerCfa3SubscriptionCheck.checkCfa3NotesSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  examPlanData,
                );
                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage == '' &&
          resp.profileInfo.cfaUnlimitedActiveExam == ''
        ) {
          this.setState({ showFreePremium: true });
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;

                isInArray_var = Cfa3SubscriptionCheck.checkCfa3NotesSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );

                //console.log(isInArray_var);
                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
    // });
  }

  componentWillUnmount() {
    if (this.dispose) this.dispose();
  }

  goToNotes = async () => {
    const { lastRecord, lastAttempt } = this.state;

    if (lastAttempt) {
      let path = AppRoutes.CFA3_BEGIN_NOTES.replace(':notesid', lastRecord.cfa3_note.chapter_id)
        .replace(':readingid', lastRecord.cfa3_note.reading_id)
        .replace(':id', lastRecord.cfa3_note.id)
        .replace(':chapter', 0);
      this.context.router.push({
        pathname: path,
      });
    }
  };
  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };
  getAdditionalResources = type => {
    const { token, idname } = this.state;
    const typeNames = {
      FS: 'Formula sheet',
      ES: 'Essential summary',
      RS: 'Ratio sheet',
    };
    const typeName = typeNames[type];
    const data = {
      token,
      idname,
      type: typeName,
      exam: examNameAccordingToDB.CFA_LEVEL_3,
    };
    FD.callAPI(`${App_data.backend_api}/cfa_2_2025question_bank/getAdditionalResources`, data).then(
      response => {
        if (response.success) {
          this.setState({ ValidToken: true });
          openPDF(response);
        } else {
          this.setState({ ValidToken: false });
        }
        return response;
      },
    );
  };
  checkSubscription = type => {
    var user_data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;
          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });

          const selectedExams = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          const dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: selectedExams,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                let isSubscribed = false;

                // #261 — pass examPlanData so mock-only partners hit the
                // early-return false.
                const examPlanData = resp_exam.examPlan && resp_exam.examPlan[0];
                isSubscribed = await PartnerCfa3SubscriptionCheck.checkCfa3Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  examPlanData,
                );
                if (isSubscribed) {
                  this.getAdditionalResources(type);
                } else {
                  this.toggleAlert();
                }
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this.toggleAlert();
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          const selectedExams = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          const dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: selectedExams,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                let isSubscribed = false;

                isSubscribed = Cfa3SubscriptionCheck.checkCfa3Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isSubscribed) {
                  this.getAdditionalResources(type);
                } else {
                  this.toggleAlert();
                }
              }
            },
          );
        }
      }
    });
  };

  render() {
    const { dropdownOpen } = this.state;
    let chapters = this.state.chapters;
    let data = '';
    const { lastAttempt } = this.state;
    if (this.state.chapters.length) {
      data = chapters.map((item, index) => (
        <div className='col-md-6 col-lg-6 col-xl-4 question_box free-premium-section' key={item.id}>
          <div
            className='question_bank_wrap pointer_class'
            key={item.id}
            onClick={this._getReadings.bind(this, item)}
          >
            {this.state.showFreePremium ? (
              item.id === 1 ? (
                <div className='tag-tile free'> {language.LC().FREE} </div>
              ) : (
                <div className='tag-tile premium'> {language.LC().PREMIUM} </div>
              )
            ) : null}
            <div className='margin_bottom_30'>
              <img
                src={App_data.frontend_url + '/img/notes/notes_icon1.svg'}
                className=''
                width='40'
                alt=''
              />
            </div>

            <div className='question_title' key={item.id} value={item.id}>
              <a>
                {/* <a className="pointer_class" id={item.chapter_name} value={item.chapter_no} onClick={this._getReadings.bind(this, item)}>*/}
                {index + 1}. {item.chapter_name}
                {/*</a>*/}
              </a>
            </div>

            <ul key={item.chapter_name}>
              <li>
                <span>
                  <img
                    src={App_data.frontend_url + '/img/notes/notes_icon2.svg'}
                    className=''
                    width='24'
                    alt=''
                  />
                </span>
                <span>
                  {/*Total Readings:*/} {item.Countreading}
                </span>
                <div className='tootip_box'>{language.LC().TOTAL_READINGS}</div>
              </li>

              <li>
                <span>
                  <img
                    src={App_data.frontend_url + '/img/notes/notes_icon3.svg'}
                    className=''
                    width='20'
                    alt=''
                  />
                </span>
                <span>
                  {/*Total Learning Objectives: */}
                  {item.Countquestion}
                </span>
                <div className='tootip_box'>{language.LC().TOTAL_NOTES}</div>
              </li>
            </ul>
          </div>
        </div>
      ));
    } else if (this.state.isNotesNotFound) {
      data = (
        <div className='col-12 text-center mt-3'>
          <img
            src={App_data.frontend_url + '/img/notes/notes_icon1_blue.svg'}
            className=''
            width='54'
            alt=''
          />
          <h5 className='mt-1'>{language.LC().NOTE_NOT_FOUND}</h5>
        </div>
      );
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }

    return (
      <div className='animated fadeIn'>
        <div className='margin_bottom_20 d-flex justify-content-between'>
          <h1 className='section_head'>{language.LC().NOTES}</h1>
          <div>
            <ButtonDropdown isOpen={dropdownOpen} toggle={this.toggle}>
              <DropdownToggle
                className='btn btn-primary pointer_class tooltip_wrap margin_right_20'
                caret
              >
                {messages.ADDITIONAL_RESOURCES}
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem
                  value='private'
                  onClick={() => {
                    this.checkSubscription('FS');
                  }}
                >
                  <i className='fa fa-print color-black' aria-hidden='true' />
                  {messages.FORMULA_SHEET}
                </DropdownItem>
              </DropdownMenu>
            </ButtonDropdown>
            {lastAttempt && (
              <button
                className='btn btn-primary pointer_class'
                onClick={this.goToNotes}
                disabled={!lastAttempt}
              >
                {messages.GO_TO_MY_LAST_READ_NOTE}
              </button>
            )}
          </div>
        </div>

        <div className='row'>
          <div className='col-12 seperator-block-wrap'>
            <div className='card'>
              <div className='card-block'>
                <div className='card-block'>
                  <div className='row'>{data}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />
      </div>
    );
  }
}

export default Notes;



// WEBPACK FOOTER //
// ./src/views/CFA3/Notes/Notes.js